/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PosSession } from '../../models/pos-session';
import { UpdateSessionCashDto } from '../../models/update-session-cash-dto';

export interface PosSessionsControllerUpdateSessionCash$Params {

/**
 * POS Session ID
 */
  id: string;
      body: UpdateSessionCashDto
}

export function posSessionsControllerUpdateSessionCash(http: HttpClient, rootUrl: string, params: PosSessionsControllerUpdateSessionCash$Params, context?: HttpContext): Observable<StrictHttpResponse<PosSession>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerUpdateSessionCash.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosSession>;
    })
  );
}

posSessionsControllerUpdateSessionCash.PATH = '/pos/sessions/{id}/cash';
